import {Component, EventEmitter, inject, input, InputSignal, Output} from '@angular/core';
import {
  AuthenticationService,
  IMenuOption,
  ISideNavContentItemComponent,
  LoginStore,
  TSideNavContentItem
} from 'frontier/browserkit';
import {MatDrawer, MatDrawerContainer, MatDrawerContent} from '@angular/material/sidenav';
import {Router} from '@angular/router';
import {ISideNavContentCategory} from './side-nav-content/side-nav-content-category.interface';
import {SideNavContentComponent} from './side-nav-content/side-nav-content.component';
import {ToolbarComponent} from './toolbar/toolbar.component';
import {ApiConfigService, StoreService, ThemeService} from 'frontier/nucleus';
import {TabsComponent} from './tabs/tabs.component';
import {TabsService} from './tabs/tabs.service';
import {ITab} from 'frontier/browserkit/src/lib/components/home-without-gl/tabs/tab.interface';

@Component({
  selector: 'lib-home-without-gl',
  standalone: true,
  imports: [
    MatDrawer,
    MatDrawerContainer,
    MatDrawerContent,
    SideNavContentComponent,
    ToolbarComponent,
    TabsComponent,
  ],
  templateUrl: './home-without-gl.component.html',
  styleUrl: './home-without-gl.component.scss'
})
export class HomeWithoutGlComponent {
  themeService = inject(ThemeService);
  private _tabsService = inject(TabsService);
  private _store = inject(StoreService);
  private _apiConfigService = inject(ApiConfigService);
  private _authService = inject(AuthenticationService);
  private _loginService = inject(LoginStore);
  private _router = inject(Router);
  sidePanelCategories: InputSignal<ISideNavContentCategory[]> = input.required<ISideNavContentCategory[]>();
  multipleInstancesCategoryIds: InputSignal<string[]> = input<string[]>([]);
  productName = input<string>();
  showTenantMenu = input<boolean>(true);
  logoPath = input<string>(null);
  customLogo = input<string>(null);
  menuOptions = input<IMenuOption[]>([]);
  versionNumber = input<string>('');
  helpUrl: InputSignal<string> = input<string | null>('');
  supportUrl: InputSignal<string> = input<string | null>('https://support.digitalgedacht.de');
  helpView: InputSignal<ISideNavContentItemComponent> = input<ISideNavContentItemComponent | null>(null);
  showHelpIcons: InputSignal<boolean> = input<boolean | null>(false);
  tabs = this._tabsService.tabs;
  selectedTabIndex = this._tabsService.selectedTabIndex;
  @Output() optionTriggered = new EventEmitter<any>()
  @Output() openHelp: EventEmitter<string> = new EventEmitter<string>();

  logout() {
    this._store.resetLastLogin();
    if (this._store.isAuthenticated()) {
      if (this._apiConfigService.environment.env !== 'prod') {
        setTimeout(() => {
          this._authService.deleteSession();
        }, 500)
      }
      this._loginService.logout()
        .subscribe(() => {
          this._loginService.loggedOut$.emit();
          this._router.navigate(['/login']);
        });
    } else {
      console.log('not authenticated');
      this._loginService.loggedOut$.emit();
      this._router.navigate(['/login']);
    }
  }

  onSideNavItemClick(item: TSideNavContentItem): void {
    if (item.beforeOpenedHandler){
      item.beforeOpenedHandler();
    }

    if ('link' in item) {
      // open the link
      window.open(item.link, '_blank');
    } else {
      console.log(item);
      console.log(this.tabs())
      const tab: ITab = this.tabs().find((tab: ITab): boolean => tab.tabId === item.tabId);

      // prevent adding the same tab twice
      if (!tab || this.multipleInstancesCategoryIds().includes(tab.tabId)) {
        this._tabsService.openTab(item.title, item.componentName, item.tabId, item.alert);
        return;
      }

      this._tabsService.selectTabById(item.title);
    }
  }
}
